<template>  
  <modal 
    :show.sync="show"
    modal-classes="modal-dialog-centered modal-login"
    @close="close">
    <div 
      slot="base-content" 
      class="card card-plain card-login mb-0">
      <div class="modal-header justify-content-center">
        <button 
          type="button" 
          class="btn-sm close text-dark" 
          data-dismiss="modal" 
          aria-hidden="true"
          @click="close">
          <i class="now-ui-icons ui-1_simple-remove"/>
        </button>
        <div class="header header-primary text-center">
          <div class="logo-container w-100">
            <img 
              v-lazy="'img/logo.jpg'" 
              alt="">
          </div>
        </div>
      </div>
      <ValidationObserver 
        v-slot="{ handleSubmit }"
        ref="resetForm">
        <form 
          class="form"
          @submit.prevent="handleSubmit(onSubmit)">
          <div class="modal-body">
            <div 
              v-if="step===0"
              class="card-body">
              <ValidationProvider 
                name="Email" 
                rules="required|email">
                <div slot-scope="{ errors }">
                  <fg-input
                    :value="email" 
                    :error="errors[0]"
                    class="input-lg"
                    addon-left-icon="now-ui-icons ui-1_email-85"
                    placeholder="Email"
                    @input="email=$event.target.value"/>
                </div>
              </ValidationProvider>
              <div 
                v-if="status !== -1"
                class="alert alert-danger mb-0" 
                role="alert">
                {{ alertMsg }}
              </div>
            </div>
            <div 
              v-if="step===1"
              class="card-body">
              <ValidationProvider 
                name="Validation Code" 
                rules="required|length:6">
                <div slot-scope="{ errors }">
                  <fg-input
                    :value="code" 
                    :error="errors[0]"
                    class="input-lg"
                    addon-left-icon="now-ui-icons business_briefcase-24"
                    placeholder="Validation Code"
                    @input="code=$event.target.value"/>
                </div>
              </ValidationProvider>
              <div 
                v-if="status !== -1"
                class="alert alert-danger mb-0" 
                role="alert">
                {{ alertMsg }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <n-button
              :disabled="loading" 
              native-type="submit"
              type="success" 
              round 
              size="lg"
              class="w-100">
              {{ loading ? '' : 'Send' }}
              <i 
                v-if="loading" 
                class="bx bx-loader bx-spin"/>
            </n-button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import { mapState, mapMutations } from 'vuex';
  import { Button, FormGroupInput, Modal } from '@/components';

  export default {
    components: {
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      Modal
    },
    data: function () {
      return {
        show: false,
				step: 0,
				email: '',
				code: '',
				loading: false,
				status: -1,
				alertMsg: '',
      }      
		},
    computed: {
      ...mapState([
        'forgotModal'
      ])
    },
    watch: {
      forgotModal() {
        this.show = this.forgotModal;
      }
    },
    methods: {
      ...mapMutations([
        'setForgotModal',
        'setAccessToken',
        'setMember',
      ]),
      onSubmit: function () {
        this.loading = true;
				this.status = -1;
				switch (this.step) {
					case 0:
						this.onRequest();
						break;
					case 1:
						this.onSendCode();
					default:
						break;
				}
			},
			onRequest: function () {
        axios.post('member/forgotpassword', {
          email: this.email
        }).then(res => {
					this.loading = false;
					this.$refs.resetForm.reset();
					this.step = 1;
        }).catch(err => {
          console.error('forgotpassword: ', err.response);
          this.loading = false;
					this.status = err.response.status;
					this.alertMsg = 'Email doesn\'t exist.';
        })
			},
			onSendCode: function () {
        axios.post('member/forgotpassword/validate', {
					email: this.email,
					code: this.code
        }).then(res => {
          const { data } = res;
          localStorage.setItem('accessToken', data.accessToken);
          this.setAccessToken(data.accessToken);
          localStorage.setItem('member', JSON.stringify(data.member));
          this.setMember(data.member);
          this.loading = false;
          this.$router.push('/settings');
          this.close();
        }).catch(err => {
          console.error('validate: ', err.response);
          this.loading = false;
					this.status = err.response.status;
					this.alertMsg = 'Validation code is not correct.';
        })
			},
      close: function () {
				this.step = 0;
        this.email = '';
        this.code = '';
				this.$refs.resetForm.reset();
				this.status = -1;
        this.setForgotModal(false);
      }
    }
  }
</script>

<style scoped lang='scss'>
  ::v-deep .modal-login {
    max-width: 360px !important;
    
    @media (max-width: 576px) {
      max-width: 320px !important;
      margin-left: auto;
      margin-right: auto;
    }

    .modal-header {
      .logo-container {
        margin-bottom: 0 !important;
      }
    }

    .modal-footer {
      display: block;
    }
  }
</style>
